import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IParams } from '../../../model/shared/IParams';
import { useTranslation } from 'react-i18next';
import { useSearchQuery } from '../../../shared/hooks/useSearchQuery';
import { StepperType } from '../brand';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import StepOne from './components/StepOne';
import { getCorrectRegisterStepper } from '../../../shared/functions/Functions';
import { StepTwo } from './components/StepTwo';
import { StepThree } from './components/StepThree';

const RegisterGlobalDiscovery = () => {
    const navigate = useNavigate();
    const { stepId } = useParams<keyof IParams>();
    const stepIdNumber = Number(stepId);
    const { t } = useTranslation();
    const token = useSearchQuery('token') as string;

    const handleBackStep = () => {
        navigate(`/global-discovery/register/step/${stepIdNumber - 1}?token=${token}`);
    };

    const step: StepperType = {
        1: (
            <GoogleReCaptchaProvider reCaptchaKey={process.env.VITE_RECAPTCHA_SITE_KEY as string}>
                <StepOne stepIdNumber={stepIdNumber} handleBackStep={handleBackStep} />
            </GoogleReCaptchaProvider>
        ),
        2: <StepTwo stepIdNumber={stepIdNumber} handleBackStep={handleBackStep} />,
        3: <StepThree stepIdNumber={stepIdNumber} handleBackStep={handleBackStep} />,
    };

    const CurrentStep = useCallback(() => {
        return step[stepIdNumber];
    }, [stepIdNumber]);

    return (
        <>
            {getCorrectRegisterStepper('registerDiscovery', `${stepId}`)}
            <CurrentStep />
        </>
    );
};

export default RegisterGlobalDiscovery;
